var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlowingMapRock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter0_f_2637_3135)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 17,
    fill: "#FC6359"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2637_3135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_2637_3135",
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 38,
    width: 38,
    height: 38,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 38,
    y: 38,
    width: 38,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6275 41C63.3552 46.2879 67.7121 50.6448 73 50.3725C69.0736 53.9212 69.0736 60.0788 73 63.6275C67.7121 63.3552 63.3552 67.7121 63.6275 73C60.0788 69.0736 53.9212 69.0736 50.3725 73C50.6448 67.7121 46.2879 63.3552 41 63.6275C44.9264 60.0788 44.9264 53.9212 41 50.3725C46.2879 50.6448 50.6448 46.2879 50.3725 41C53.9124 44.9264 60.0788 44.9264 63.6275 41Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.6275 41C63.3552 46.2879 67.7121 50.6448 73 50.3725C69.0736 53.9212 69.0736 60.0788 73 63.6275C67.7121 63.3552 63.3552 67.7121 63.6275 73C60.0788 69.0736 53.9212 69.0736 50.3725 73C50.6448 67.7121 46.2879 63.3552 41 63.6275C44.9264 60.0788 44.9264 53.9212 41 50.3725C46.2879 50.6448 50.6448 46.2879 50.3725 41C53.9124 44.9264 60.0788 44.9264 63.6275 41Z",
    fill: "#FC6359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6275 41C63.3552 46.2879 67.7121 50.6448 73 50.3725C69.0736 53.9212 69.0736 60.0788 73 63.6275C67.7121 63.3552 63.3552 67.7121 63.6275 73C60.0788 69.0736 53.9212 69.0736 50.3725 73C50.6448 67.7121 46.2879 63.3552 41 63.6275C44.9264 60.0788 44.9264 53.9212 41 50.3725C46.2879 50.6448 50.6448 46.2879 50.3725 41C53.9124 44.9264 60.0788 44.9264 63.6275 41Z",
    stroke: "#232323",
    strokeWidth: 2,
    mask: "url(#path-2-outside-1_2637_3135)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2637_3135",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_2637_3135"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2637_3135",
    x: 34.2437,
    y: 38.2382,
    width: 45.5127,
    height: 45.5181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2637_3135"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2637_3135",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlowingMapRock);
export default __webpack_public_path__ + "static/media/glowing_map_rock.ca91da32cbb7c921b0e6741ba0c50867.svg";
export { ForwardRef as ReactComponent };